import { FormattedMessage } from 'react-intl';
import { Heading, SimpleGrid } from '@chakra-ui/react';

import ComboboxFormikField from '../forms/ComboboxFormikField';

const BatteryDefinitions = ({ idx, formLabels, definitions }) => {
    return (
        <>
            <Heading as="h4" variant="h4">
                <FormattedMessage id="batteries_definitions_heading" />
            </Heading>

            <SimpleGrid columns={{ xl: 3 }} spacingX={6}>
                <ComboboxFormikField
                    id={'batteryTypeId' + idx}
                    name={`subBatteries[${idx}].batteryTypeId`}
                    mt={3}
                    label={formLabels.batteryType}
                    options={definitions.batteryTypes}
                    labelKey="description"
                    valueKey="id"
                    placeholderLabel={formLabels.selectPlaceholder}
                />
            </SimpleGrid>
        </>
    );
};

export default BatteryDefinitions;
